const TILINGS_LIST = [
  [ `4x1`, `4x1`, `3x3`, `1x5`, `1x3` ],
  [ `1x4`, `1x4`, `3x3`, `5x1`, `3x1` ],
  [ `1x2`, `4x1`, `3x1`, `2x2`, `s1h`, `small-l1`, `big-l3` ],
  [ `1x2`, `4x1`, `3x1`, `2x2`, `s1h`, `small-l4`, `big-l2` ],
  [ `2x1`, `1x4`, `1x3`, `2x2`, `s1v`, `small-l2`, `big-l1` ],
  [ `2x1`, `1x4`, `1x3`, `2x2`, `s1v`, `small-l3`, `big-l4` ],
  [ `1x1`, `1x4`, `1x4`, `4x1`, `1x3`, `2x1`, `small-l2`, `s2v` ],
  [ `1x1`, `1x4`, `1x4`, `4x1`, `1x3`, `2x1`, `small-l3`, `s2v` ],
  [ `1x1`, `4x1`, `4x1`, `1x4`, `3x1`, `1x2`, `small-l4`, `s2h` ],
  [ `1x1`, `4x1`, `4x1`, `1x4`, `3x1`, `1x2`, `small-l1`, `s2h` ],
  [ `big-l1`, `small-l2`, `3x3`, `2x1`, `1x3`, `3x1` ],
  [ `big-l4`, `small-l3`, `3x3`, `2x1`, `1x3`, `3x1` ],
  [ `big-l2`, `small-l4`, `3x3`, `1x2`, `3x1`, `1x3` ],
  [ `big-l3`, `small-l1`, `3x3`, `1x2`, `3x1`, `1x3` ],
  [ `t1`, `s2h`, `3x1`, `1x3`, `2x1`, `1x4`, `1x5` ],
  [ `t2`, `s2h`, `3x1`, `1x3`, `2x1`, `1x4`, `1x5` ],
  [ `t3`, `s2v`, `1x3`, `3x1`, `1x2`, `4x1`, `5x1` ],
  [ `t4`, `s2v`, `1x3`, `3x1`, `1x2`, `4x1`, `5x1` ],
  [ `2x2`, `t1`, `s2v`, `1x2`, `4x1`, `small-l2`, `small-l3`, `1x1` ],
  [ `2x2`, `t2`, `s2v`, `1x2`, `4x1`, `small-l2`, `small-l3`, `1x1` ],
  [ `2x2`, `t4`, `s2h`, `2x1`, `1x4`, `small-l1`, `small-l4`, `1x1` ],
  [ `2x2`, `t3`, `s2h`, `2x1`, `1x4`, `small-l1`, `small-l4`, `1x1` ],
  [ `small-l1`, `small-l4`, `2x2`, `s1h`, `small-l3`, `t1`, `1x3`, `1x1` ],
  [ `small-l1`, `small-l4`, `2x2`, `s1h`, `small-l2`, `t2`, `1x3`, `1x1` ],
  [ `small-l2`, `small-l3`, `2x2`, `s1v`, `small-l4`, `t3`, `3x1`, `1x1` ],
  [ `small-l2`, `small-l3`, `2x2`, `s1v`, `small-l1`, `t4`, `3x1`, `1x1` ],
  [ `1x4`, `3x3`, `1x1`, `2x1`, `t4`, `big-l4` ],
  [ `1x4`, `3x3`, `1x1`, `2x1`, `t3`, `big-l1` ],
  [ `4x1`, `3x3`, `1x1`, `1x2`, `t1`, `big-l2` ],
  [ `4x1`, `3x3`, `1x1`, `1x2`, `t2`, `big-l3` ],
  [ `small-l3`, `s1h`, `small-l2`, `1x4`, `big-l3`, `1x2`, `2x2` ],
  [ `small-l3`, `s1h`, `small-l2`, `1x4`, `big-l2`, `1x2`, `2x2` ],
  [ `small-l1`, `s1v`, `small-l4`, `4x1`, `big-l4`, `2x1`, `2x2` ],
  [ `small-l1`, `s1v`, `small-l4`, `4x1`, `big-l1`, `2x1`, `2x2` ],
  [ `5x1`, `big-l1`, `1x1`, `1x3`, `small-l1`, `small-l2`, `big-l4` ],
  [ `5x1`, `big-l1`, `1x1`, `1x3`, `small-l3`, `small-l4`, `big-l4` ],
  [ `1x5`, `big-l2`, `1x1`, `3x1`, `small-l2`, `small-l4`, `big-l3` ],
  [ `1x5`, `big-l2`, `1x1`, `3x1`, `small-l1`, `small-l3`, `big-l3` ],
];

module.exports = {
  TILINGS_LIST
};
